var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCounty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#324c5e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3185.375 -683.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3248.186,683.75h-61.621a1.189,1.189,0,0,0-1.189,1.189v61.621a1.189,1.189,0,0,0,1.189,1.189h61.621a1.189,1.189,0,0,0,1.189-1.189V684.939A1.19,1.19,0,0,0,3248.186,683.75ZM3247,745.371h-59.242V690.684l.886-.768-.742-.856-.144.125v-3.056H3247Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.708,
    transform: "matrix(0.756, -0.655, 0.655, 0.756, 3188.616, 693.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3216.434,740.882h1.676V738.5h-.589l-.386-.446-1.8,1.558Z",
    transform: "translate(-23.174 -42.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3240,742.4h1.133v-.057h1.189v-2.322H3240v1.189h-.057v1.133H3240Z",
    transform: "translate(-42.205 -43.526)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 700.936)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 722.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 717.857)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 705.166)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 713.627)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 726.317)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.115,
    transform: "translate(3197.737 709.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3242.772,891.377l-.452-.433v-.626h-2.378v1.64l1.183,1.136Z",
    transform: "translate(-42.205 -159.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.362,
    height: 2.379,
    transform: "translate(3218.656 737.105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.362,
    height: 2.379,
    transform: "translate(3213.932 737.105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.362,
    height: 2.379,
    transform: "translate(3209.208 737.105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 2.362,
    transform: "translate(3200.624 734.959) rotate(-46.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3270.539,919.626v-2.379h-.553l-.614-.59-1.647,1.716,1.3,1.253Z",
    transform: "translate(-63.693 -180.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3354.075,919.262h-1.133v.057h-.057v1.133h.057v1.189h2.322v-2.322h-1.189Z",
    transform: "translate(-129.561 -182.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.379,
    height: 1.651,
    transform: "translate(3223.324 733.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3355.208,887.4h-2.322v2.322h1.189v.057h1.133v-.057h.057v-1.133h-.057Z",
    transform: "translate(-129.561 -157.513)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.241,
    height: 2.379,
    transform: "translate(3236.849 729.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.241,
    height: 2.379,
    transform: "translate(3227.887 729.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.241,
    height: 2.379,
    transform: "translate(3241.331 729.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.241,
    height: 2.379,
    transform: "translate(3232.368 729.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.133,
    height: 2.379,
    transform: "translate(3245.812 729.886)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3289.395,747.8h11.932c.016,0,.03,0,.045,0s.033.005.051.005h.013a1.189,1.189,0,0,0,1.177-1.2c-.013-1.293-.029-4.148-.029-5.359a.832.832,0,1,1,1.627,0c0,1.286-.017,4.156-.029,5.359a1.189,1.189,0,0,0,1.177,1.2h.012l.019,0H3317.4a1.189,1.189,0,0,0,1.189-1.189,1.2,1.2,0,0,0-.013-.133,1.164,1.164,0,0,0,.013-.131V736.339c0-.022-.005-.043-.006-.065v-.012a1.186,1.186,0,0,0-1.182-1.113c-.011,0-.021,0-.031,0l-7.16-2.108v-4.659a1.186,1.186,0,0,0-.35-1.031l-5.271-5.075v-.993h4.934a1.189,1.189,0,0,0,1.189-1.189v-3.863a1.189,1.189,0,0,0-1.189-1.189h-6.109a1.249,1.249,0,0,0-1.2,1.236v6.007l-5.271,5.066a1.185,1.185,0,0,0-.349,1.037v4.653l-7.161,2.108c-.011,0-.021,0-.031,0a1.186,1.186,0,0,0-1.182,1.115v.007c0,.023-.007.044-.007.067V746.35a1.146,1.146,0,0,0,.013.13,1.12,1.12,0,0,0-.014.135A1.189,1.189,0,0,0,3289.395,747.8Zm14-9.943a3.3,3.3,0,0,0-3.192,3.383c0,.916.008,2.768.019,4.181h-1.258V728.7l4.435-4.263,4.427,4.263v16.723h-1.258c.01-1.378.019-3.219.019-4.181A3.3,3.3,0,0,0,3303.4,737.862Zm12.812-.571v8.135h-1.8v-5.937a1.189,1.189,0,1,0-2.378,0v5.937h-1.828v-9.9Zm-7.878-18.384h-3.745v-1.485h3.745Zm-11.744,26.518h-1.761v-5.937a1.189,1.189,0,1,0-2.378,0v5.937h-1.863v-8.134l6-1.768Z",
    transform: "translate(-79.534 -24.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3347.317,776.794a2.327,2.327,0,1,0,2.327,2.327A2.33,2.33,0,0,0,3347.317,776.794Zm-.052,2.327a.052.052,0,1,1,.1,0C3347.369,779.178,3347.266,779.178,3347.266,779.121Z",
    transform: "translate(-123.455 -71.965)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCounty);
export default __webpack_public_path__ + "static/media/icon-county.299117a52b272a08f939599c9044ee01.svg";
export { ForwardRef as ReactComponent };